import { action, ActionType } from 'typesafe-actions';
import { Props } from '.';

export const ACTIVATE = 'PERSONAL_SECTION/ACTIVATE';
export const DEACTIVATE = 'PERSONAL_SECTION/DEACTIVATE';

interface ActivateProps extends Props {
  pathname: string;
  needRefresh: boolean;
}

export const lifecycle = {
  activate: ({ backTo, scope, pathname, needRefresh }: ActivateProps) =>
    action(ACTIVATE, { backTo, scope, pathname, needRefresh }),
  deactivate: () => action(DEACTIVATE),
};

export type Action = ActionType<typeof lifecycle>;
